import { Flex, Loading } from "@100mslive/roomkit-react";

const FullPageProgress = () => (
  <Flex justify="center" align="center" css={{ size: "100%" }}>
    <Loading size={100} />
  </Flex>
);

export default FullPageProgress;
